// extracted by mini-css-extract-plugin
export var actions = "_9x-8";
export var arrow = "_9x-5";
export var card = "_9x-0";
export var cardWrapper = "_9x-9";
export var fieldName = "_9x-3";
export var newValue = "_9x-6";
export var oldValue = "_9x-4";
export var orangeGlowFade = "_9x-c";
export var productSection = "_9x-1";
export var scrollToBottom = "_9x-b";
export var scrollToBottomAnchor = "_9x-a";
export var scrollToBottomIcon = "_9x-d";
export var showAllButton = "_9x-7";
export var table = "_9x-2";